// extracted by mini-css-extract-plugin
module.exports = {"activity_report__wrapper":"ActivityReportPage_activity_report__wrapper__mt1fO","activity_report__title_container":"ActivityReportPage_activity_report__title_container__v2Cz_"};